import { SET_ACCESSIBILITY, AccessAction, AccessState } from '../type';
const localStorageAccess = localStorage.getItem('accessibility');

const initialState: AccessState = {
    Accessibility: localStorageAccess ? localStorageAccess : 'OFF'
};
const accessReducer = (state = initialState, action: AccessAction) => {
    switch (action.type) {
        case SET_ACCESSIBILITY:
            return {
                ...state,
                Accessibility: action.payload
            };
        default:
            return state;
    }
};

export default accessReducer;
